import styled, { css } from 'styled-components';
import { rem, em } from 'polished';
import { Heading } from 'elements';
import { HeadingBase } from 'elements/Heading/styled';
import { media, Flex } from 'core/layout';
import { colors, accessibilityBorder, themed } from 'core/theme';

const backgroundColor = (props) => themed(
  Object.assign({}, colors.lightThemed, {
    light: colors.W,
  })
);

const labelColor = (props) => themed(
  Object.assign({}, colors.darkThemed, {
    light: colors.B72,
  })
);

export const StyledContentP = styled.p`
 ${({width}) => width && css`
    width: ${width * 100}%;
  `};
`;

export const StyledContent = styled.article`
  margin-top: 2.5em;
  margin-bottom: 2.5em;

   
  ${({width}) => width && css`
    width: ${width * 100}%;
  `};
    
    p {

    }


  h1:first-child {
    margin-bottom: 1em;
  }
  
  h3:first-child {
    margin-bottom: 1em;
  }
  
  ${media.tabletSmall`
    font-size: ${20/24}rem;
  `};
`;

export const StyledTop = styled.article`
  margin-top: ${rem(40)};
  margin-bottom: ${rem(28)};

`;

export const Small = styled.small`
    color: ${colors.lightText};
    padding-top:${rem(4)};
    display:block;
`;

export const Label = styled.label`
  pointer-events: none;
  color: ${labelColor};
  font-size: ${rem(14)};
  margin-bottom:${rem(8)};
  display:block;

`;


export const Atsauce = styled.div`
 
  color: ${labelColor};
  font-size: ${em(14)};
 

`;



export const Form = styled.form`
  position: relative;
  
   
  ${({width}) => width && css`
    width: ${width * 100}%;
  `};



  input, textarea {
    background-color: ${backgroundColor};
    border: 1px solid #E0E0E0;  
    border-radius: 2px;
    color: ${colors.text};
    font-size: ${em(16)};
    width: 100%;
    padding: 0.5em 1em;

    &::-webkit-search-cancel-button {
      -webkit-appearance: none;
    }

    &::-ms-clear {
      display: none;
    }

    &:not([value=""]) + label > span {
      // display: none;
    }

    ${accessibilityBorder};
  }
`;


export const InputContainer = Flex.extend`
  margin: 0 0 ${em(32)};

  & > div {
    padding-top: 0;
    padding-left: 0;
  }

  ${media.tablet`
    margin: 0 0 ${em(8)};

    & > div {
      flex: 0 0 100%;
    }
  `};
`;


// WEBPACK FOOTER //
// ./src/pages/PasvaldibasKontakti/styled.js